import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import FlagLineItemForm, {
    FlagLineItemFormProps
} from "../../../pages/reimbursements/components/claims/FlagLineItemForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, FlagLineItemFormProps {
}

type Props = OwnProps;

// @ts-ignore
const FlagLineItemModal = NiceModal.create<Props>(({lineItemFlag, onClose, header,...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <FlagLineItemForm lineItemFlag={lineItemFlag} {...rest}/>
        </SlideOver>
    )
})

export default FlagLineItemModal;
